import { render, staticRenderFns } from "./ExpedientePersonalSection.vue?vue&type=template&id=7e934a54&scoped=true"
import script from "./ExpedientePersonalSection.vue?vue&type=script&lang=js"
export * from "./ExpedientePersonalSection.vue?vue&type=script&lang=js"
import style0 from "./ExpedientePersonalSection.vue?vue&type=style&index=0&id=7e934a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e934a54",
  null
  
)

export default component.exports